export default __webpack_public_path__ + "static/media/toyota-vehicle.d025413a.svg";